import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {Owner} from "../../model/customer/owner";
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {MoneyOwner} from "../../model/customer/money-owner";

@Injectable({
  providedIn: 'root'
})
export class CustomerMoneyOwnerService extends CommonCrudService<MoneyOwner> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_MONEY_OWNER_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_MONEY_OWNER,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_MONEY_OWNER);
  }

}
